/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoid comparing a paid Excel desktop license with GridCraft without checking which Excel capabilities you actually use. If a free web edition already covers a simple collaborative task, that is a different comparison from an offline workbook with VBA. Conversely, a preference for local files or inspectable source code can be a real requirement even when a cloud option is inexpensive.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不要只拿付费 Excel 桌面许可与 GridCraft 对比，而忽略实际需要的 Excel 能力。如果免费网页版已经能满足简单协作任务，那与离线 VBA 工作簿是两种不同的比较。反过来，即使云端方案便宜，本地文件或可检查的源码仍可能是实际需求。`)
};

/**
* | output |
* | --- |
* | "Avoid comparing a paid Excel desktop license with GridCraft without checking which Excel capabilities you actually use. If a free web edition already covers ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_1 as "gc.search_guides.gridcraft_vs_excel.sections.6.paragraphs.1" }